export { SidePanels } from './SidePanels';
